import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '5.8fr 6fr 6fr 8.4fr 1.72fr',

    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '6fr 6fr 6fr 9fr 1fr'
    },
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    backgroundColor: theme.palette.background.paper,
    marginTop: 4,
    marginBottom: 4,
    borderRadius: 12,
    [theme.breakpoints.between(960, 1200)]: {
      gridTemplateColumns: '5.7fr 6.2fr 6fr 8.3fr 1fr'
    }
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: theme.palette.text.secondary,
    padding: '0 0 0 12px',
    backgroundColor: theme.palette.background.paper,

    marginBottom: 4,
    marginTop: 4,
    borderRadius: 12,
    alignItems: 'center'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    },
    borderRadius: 20,

    transition: 'background-color 0.3s ease-in-out',
    display: 'grid',
    gridTemplateColumns: '6fr 6fr 6fr 9fr 1fr',
    height: 55,
    [theme.breakpoints.up(1440)]: {
      height: 100
    },
    alignItems: 'center',
    paddingLeft: 12,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left'
  },
  tableRowSkeleton: {
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    },
    borderRadius: 20,

    transition: 'background-color 0.3s ease-in-out',
    display: 'grid',
    gridTemplateColumns: '6fr 6fr 6fr 9fr 1fr',
    height: 55,
    [theme.breakpoints.up(1440)]: {
      height: 100
    },
    alignItems: 'center',
    paddingLeft: 12,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left'
  },
  nameCell: {
    display: 'flex'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  },

  textRow: {
    fontSize: 13,
    [theme.breakpoints.between(960, 1200)]: {
      fontSize: 12
    },
    [theme.breakpoints.up(1440)]: {
      fontSize: 15
    }
  }
}))

export default useStyles
